// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"71f5bacc","265":"51589c9a","936":"266493b2"}[chunkId] + ".chunk.js";
};